/**
 * @GENERATED from Figma node 3638:51962
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const SymlinkBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#7F776F"
      fillRule="evenodd"
      d="M11.245 20.974c-3.713-2.545-4.335-5.84-1.908-10.043 1.42-2.46 3.138-3.85 5.115-4.189l-1.536 2.66 2.022 1.168 3.503-6.067L12.374 1l-1.168 2.022 2.534 1.463c-2.085.442-4.435 1.831-6.426 5.279C4.242 15.086 5.23 19.75 10.074 23z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = React.forwardRef(SymlinkBright);
export { ForwardRef as SymlinkBright };
